module.exports = __webpack_public_path__ + "static/img/wx-10.3649ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx-10.png
// module id = hwfZ
// module chunks = 10